export default {
  /**
   * 近期概况
   */
  overview: '/api/owdata/statistics/overall/overview',
  /**
   * 库龄占比/效期占比
   */
  stockAgeExpiration: '/api/owdata/statistics/stock/stock-age-expiration',
  /**
   * 库存表现查询
   */
  stockAnalyze: '/api/owdata/statistics/stock/analyze',

  /** 系统监控 */
  monitor: '/api/owdata/statistics/overall/monitor',

  /**
   * 获取系统监控配置
   * * 仅用在swr url
   * @deprecated
   */
  getMonitorSetting: '/api/statistics/overall/get-monitor-setting',

  /**
   * 设置系统监控配置
   * @deprecated
   */
  updateMonitorSetting: '/api/statistics/overall/monitor-setting',

  /**
   * 库存预警查询
   * 仅用在swr url
   * @deprecated
   */
  getStockWarningSetting: '/api/statistics/stock/warn-setting/get',

  /**
   * 库存预警更新
   * @deprecated
   */
  updateStockWarningSetting: '/api/statistics/stock/warn-setting/update',

  /**
   * 商品统计（全部）
   */
  productAll: '/api/owdata/statistics/product/analyze',

  /**
   * 商品统计（热销）
   */
  productHotSale: '/api/owdata/statistics/product/best-sell',
  /**
   * 商品统计（临期）
   */
  productExpire: '/api/owdata/statistics/product/approach-expiration',
  /**
   * 商品统计（滞销）
   */
  productUnsalable: '/api/owdata/statistics/product/unsalable',
  /**
   * 商品统计（缺货）
   */
  productOutOfStock: '/api/owdata/statistics/product/lack',
  /**
   * 出库销售分析
   */
  outboundSaleAnalyze: '/api/owdata/statistics/outbound/sales-analysis',
  outboundChannelAnalyze: '/api/owdata/statistics/outbound/channel-analysis',
  /**库存周转 */
  stockTurnover: '/api/owdata/statistics/stock/turnover',
  /**出库趋势 */
  outboundTrend: '/api/owdata/statistics/outbound/trend',
  /**库存统计 */
  stockStat: '/api/owdata/statistics/stock/stat',
  /**入库趋势 */
  inboundTrend: '/api/owdata/statistics/inbound/trend',
  /**入库分析 */
  inboundAnalysis: '/api/owdata/statistics/inbound/analysis',
  /**趋势图 */
  overallTrend: '/api/owdata/statistics/overall/trend',
  /**近期概况 */
  overallCompare: '/api/owdata/statistics/overall/data-compare',
}
